module.exports = __webpack_public_path__ + "img/qr_code.39a96ddc.png";